import { createStore } from "@reduxjs/toolkit"
import videoReducer from "./Videos/VideoReducer"

const store = createStore(videoReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

export default store